import * as React from 'react';

import { error } from './error.module.scss';

const Error = ({ children }) => <div className={error}>{children}</div>;

export default Error;
